export default __webpack_public_path__ + "static/media/loanHistory.7bd5bce1.svg";